import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

// Same URL -> same SafeResourceUrl object, taake iframe baar baar reload na ho
const CACHE = new Map<string, SafeResourceUrl>();

@Pipe({ name: 'videoEmbed' })
export class VideoEmbedPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string | null | undefined): SafeResourceUrl | null {
    if (!url || typeof url !== 'string') return null;
    const clean = url.trim();
    if (CACHE.has(clean)) return CACHE.get(clean)!;

    const embed = this.toEmbedUrl(clean);
    console.log('[videoEmbed]', JSON.stringify(clean), '=>', embed);
    if (!embed) return null;

    const safe = this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    CACHE.set(clean, safe);
    return safe;
  }

  private toEmbedUrl(url: string): string {
    // ---------- YouTube ----------
    let m = url.match(
      /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    if (m) return `https://www.youtube.com/embed/${m[1]}`;

    // ---------- Vimeo ----------
    if (/vimeo\.com/i.test(url)) {
      const m = url.match(/vimeo\.com\/(?:[^?#]*\/)?(\d{6,})(?:\/([a-zA-Z0-9]+))?/);
      if (!m) return '';
      const id = m[1];
      const hash = m[2] || (url.match(/[?&]h=([a-zA-Z0-9]+)/) || [])[1];
      const t = (url.match(/#t=(\d+)/) || [])[1];

      let embed = `https://player.vimeo.com/video/${id}`;
      if (hash) embed += `?h=${hash}`;
      if (t) embed += `#t=${t}s`;
      return embed;
    }

    // ---------- Dailymotion ----------
    m = url.match(/(?:dai\.ly\/|dailymotion\.com\/(?:video|embed\/video)\/)([a-zA-Z0-9]+)/);
    if (m) return `https://www.dailymotion.com/embed/video/${m[1]}`;

    // ---------- Umyovideo ----------
    if (/^https:\/\/umyovideo\.com\/.+/.test(url)) return url;

    return '';
  }
}